import * as contentful from "contentful";

const client = contentful.createClient({
  space: "ymyae1guodc8",
  accessToken: "OpcaZhLIelU6LAGTE4fBtm8GOmoQcGClSqmdphnikus"
});

export default client;
